<manage-wrapper
  *ngIf="!!survey"
  [backgroundColor]="'var(--normal-text)'"
  [dialogTitle]="'Manage Evaluation Form'"
  [canDuplicate]="false"
  [canEditMain]="true"
  [hideLabels]="true"
  [hideDelete]="true"
  [entityTitle]="survey.title"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  (onDone)="dialogRef.close()"
  (onChangeTab)="changeTab($event)"
  (saveTitle)="updateTitle($event)"
> 
  <custom-question-manager-view
    *ngIf="!selectedTab || selectedTab?.id === 'build'"
    [questions]="survey.customQuestions"
    [addQuestionCopy]="'+ ADD QUESTION TO EVALUATION FORM'"
    [addTextCopy]="'+ ADD A TEXT BOX TO EVALUATION FORM'"
    [showCounts]="false"
    (dotMenuSelection)="dotMenuSelection($event)"
    (editQuestion)="editQuestion($event)"
    (changeIdOrder)="changeIdOrder($event)"
    (addQuestion)="addQuestion($event)"
  ></custom-question-manager-view>
  <custom-questions *ngIf="selectedTab?.id === 'preview'"
    [entity]="{ id: null, customQuestions: {} }"
    [questions]="survey.customQuestions"
    [shareView]="true"
  ></custom-questions>
  <tip-text *ngIf="selectedTab?.id === 'preview' && !survey.customQuestions.length" [type]="'tip'" [head]="'Tip:'" 
    [body]="'There are no questions added to this evaluation form.  Please click the build tab to add some'"></tip-text>
  <div class="schedule" *ngIf="selectedTab?.id === 'schedule'">
    <h3>Schedule a time for the evaluation form to show in the app</h3>
    <tip-text [type]="'tip'" [head]="'Tip:'" [body]="'All active forms that are scheduled before the current time will show up in the app'"></tip-text>
    <time-selector
      [timezones]="timezones"
      [timeZone]="survey.timeZone"
      [UTCTime]="survey.pushTime"
      (timeChange)="changeTime($event)"
    ></time-selector>
  </div>
  <div class="fillout" *ngIf="selectedTab?.id === 'fillout' && !!appInfo && !!event">
    <tip-text [type]="'tip'" [head]="'Tip:'" [body]="'Fill out a sample survey below and submit it if you\'d like.  Your answers will be saved against the survey just like a user\'s submission would be.'"></tip-text>
    <survey 
      [survey]="survey"
      [appId]="appInfo.id"
      [eventId]="event.eventId"
      [useNameEmail]="!!appInfo.nameAndEmail"
      [defaultName]="userService.fullName"
      [defaultEmail]="userService.email"
      (submitSurvey)="submitSurvey($event)"
    ></survey>
  </div>


  
</manage-wrapper>

